<template>
  <BaseCard class="featureCard" :disabled="disabled" :true-value="trueValue" :value="value" :checkbox="checkbox" :check-icon="checkIcon">
    <template v-slot:title>{{ featureObj.name }}</template>
    <template v-slot:subtitle>Feature</template>

    <Text>{{ description }}</Text>
  </BaseCard>
</template>

<script>
import { defineComponent, computed, inject } from 'vue'

import BaseCard from '@/components/cards/BaseCard'
import Text from '@/components/cards/content/Text'

import cardProps from '@/helpers/cardProps'
import parseDescription from '@/helpers/parseDescription'

import featureList from '@/data/features'

export default defineComponent({
  props: {
    feature: {
      type: String,
      required: true
    },

    ...cardProps
  },

  components: {
    Text,
    BaseCard
  },

  setup (props) {
    const feature = computed(() => {
      return featureList[props.feature]
    })

    const computedCharacter = inject('computedCharacter')
    const description = computed(() => parseDescription(computedCharacter, feature.value))

    return {
      featureObj: feature,
      description
    }
  }
})
</script>
